import { Gear } from "@phosphor-icons/react"
import { type CustomMenuItemProps, useGridMenuItem } from "ag-grid-react"
import React from "react"

export const ConfigureExtradataColumn = ({ name }: CustomMenuItemProps) => {
  useGridMenuItem({
    configureDefaults: () => true,
  })
  return (
    <div>
      <span className="ag-menu-option-part ag-menu-option-icon ag-icon-filter" role="presentation">
        {}
        <Gear height={20} width={20} weight="light" />
      </span>
      <span className="ag-menu-option-part ag-menu-option-text">{name}</span>
    </div>
  )
}
